<template>

	<section>

		<!--a
			class="btn btn-primary m-1"
			target="_blank"
			href="/files/Mode_d_emploi_v2.15_8.12.21.pdf"
			>Documentation installation
		</a>

		<a
			class="btn btn-primary m-1"
			target="_blank"
			href="/files/Aide_utilisateur-Emotivi-20200220.pdf?v=1"
			>Documentation utilisateur
		</a-->

		<div class="row">
			<div class="col">

				<div v-if="isLoading" class="d-flex justify-content-center align-items-center full-available-height">
					<div class="spinner-border text-dark" role="status">
					</div>
				</div>

				<div v-else>

					<!-- BOXES LOOP -->	
					<div v-for="(box, indexBox) in boxes" :key="indexBox">

						<h3>
							Abonnement / {{box.enduser.en_fullname}}
						</h3>

						<!-- BOX CONTAINER -->
						<div class="alert alert-light">

							<div v-if="box.enduser.en_state_subscription === 'SUSPENDED'" class="alert alert-warning">
								<icon name="exclamation-triangle" class="me-2" />
								<span>Abonnement suspendu</span>
							</div>

							<!--div v-if="es_type !=3"-->

								<h4 class="fw-bold">Historique d'abonnement</h4>
								<div
									v-if="!box.subscriptions || box.subscriptions.length === 0"
									class="alert alert-info"
								>
									Votre abonnement n'a pas encore débuté. Il débutera un mois
									après la première installation.
								</div>
								<div class="table-responsive" v-else>
									<table class="table table-striped table-sm table-responsive">
										<thead>
											<tr>
												<th scope="col">
													Description
												</th>
												<th scope="col" class="d-none d-md-table-cell">
													Démarrage
												</th>
												<th scope="col" class="d-none d-md-table-cell">
													Fin
												</th>
												<th scope="col">
													Montant
												</th>
												<th scope="col">
													État
												</th>
											</tr>
										</thead>
										<tbody>
											<tr
												v-for="(sub, indexSub) in box.subscriptions"
												:key="indexSub"
											>
												<td class="text-truncate text-wrap">
													{{sub.subscriptionData.of_id.of_name}}
												</td>
												<td class="d-none d-md-table-cell">
													{{sub.su_startdate
														? $moment(sub.su_startdate).format("DD/MM/YYYY")
														: (sub.start_date
															? $moment.unix(sub.start_date).format("DD/MM/YYYY")
															: "-")}}
												</td>
												<td class="d-none d-md-table-cell">
													<span v-if="$moment(sub.su_enddate).isValid() || $moment.unix(sub.cancel_at).isValid()">
														{{sub.su_enddate
																? $moment(sub.su_enddate).format("DD/MM/YYYY")
																: (sub.cancel_at
																	? $moment.unix(sub.cancel_at).format("DD/MM/YYYY")
																	: "-")}}
													</span>
													<span v-else> - </span>
												</td>
												<td>
													{{ Math.ceil((sub.plan.amount / 100) * 100) / 100 }}€/mois
												</td>
												<td v-if="sub.status">
													<span v-if="sub.status === 'active'">
														En cours
													</span>
													<span v-else-if="sub.status === 'unpaid'" class="text-danger">
														Impayé
													</span>
													<span v-else-if="sub.status === 'past_due'" class="text-danger">
														Impayé
													</span>
													<span v-else-if="sub.status === 'canceled'" class="text-secondary">
														Annulé
													</span>
													<span v-else-if="sub.status === 'ended'" class="text-secondary" >
														Terminé
													</span>
													<span v-else-if="sub.status === 'incomplete'" class="text-warning">
														Incomplet
													</span>
													<span v-else-if="sub.status === 'incomplete_expired'" class="text-warning">
														Incomplet et a expiré
													</span>
													<span v-else-if="sub.status === 'trialing'" style="color: lightblue">
														Période d'essai
													</span>
												</td>
												<td v-else-if="sub.hasOwnProperty('su_state')">
													<span v-if="sub.su_state === 2 && sub.su_active" class="text-success">
														En cours
													</span>
													<span v-else-if="sub.su_state === 2 && !sub.su_active" class="text-info">
														Programmé
													</span>
													<span v-else-if="sub.su_state === 1" class="text-warning">
														Annulé
													</span>
													<span v-else class="text-danger">
														Arrêté
													</span>
												</td>
											</tr>
										</tbody>
									</table>
								</div>

								<h4 class="fw-bold">Historique des paiements</h4>

								<div class="table-responsive">
									<table class="table table-striped table-sm">
										<thead>
											<tr>
												<th scope="col">Libellé</th>
												<th scope="col">Montant</th>
												<th scope="col" class="d-none d-md-table-cell">Mode de paiement</th>
												<th scope="col">Date</th>
												<th scope="col" class="d-none d-md-table-cell">Statut</th>
												<th scope="col"></th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(order, indexOrder) in box.orders" :key="indexOrder">
												<td>
													{{ order.or_name }}
												</td>
												<td>
													{{ Math.ceil((order.or_pricettc / 100) * 100) / 100 }}€
												</td>
												<td class="d-none d-md-table-cell">
													{{ getPaymentMethodDetail(order, box)}}
												</td>
												<td>
													{{ $moment(order.or_date).format("DD/MM/YYYY") }}
												</td>
												<td class="d-none d-md-table-cell">
													{{ getOrderStatus(order.or_status) }}
												</td>
												<td>
													<button class="btn btn-sm btn-primary" @click="printOrder(order, $event)">
														<icon name="print" style="fill: white"></icon>
														<span class="d-none d-md-inline-block ms-2">
															Facture
														</span>
													</button>
												</td>
											</tr>
										</tbody>
									</table>
								</div>

								<h4 class="fw-bold">Moyens de paiement</h4>
							
								<div class="table-responsive">
									<table class="table table-striped table-sm">
										<thead>
											<tr>
												<th scope="col">
													Moyen de paiement
												</th>
												<th scope="col">
													Nom associé
												</th>
												<th scope="col" class="d-none d-md-table-cell">
													Ajouté le
												</th>
												<th scope="col">
													Actif
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(paymentMethod, indexPayments) in box.paymentMethods" :key="indexPayments">
												<td class="text-capitalize">
													{{ formatPMDetails(paymentMethod)}}
												</td>
												<td>
													{{paymentMethod.pm_rib_name ? paymentMethod.pm_rib_name : paymentMethod.pm_name}}
												</td>
												<td>
													{{$moment(paymentMethod.createAt).isValid()
														? $moment(paymentMethod.createdAt).format(
															"DD/MM/YYYY [à] HH:mm"
															)
														: ""}}
												</td>
												<td class="d-none d-md-table-cell" :style="paymentMethod.pm_active ? 'color:green' : 'color:red'">
													{{paymentMethod.pm_active ? "Oui" : "Non"}}
												</td>
											</tr>
										</tbody>
									</table>
								</div>

								<div class="text-end">
									<button class="btn btn-primary" @click="beforeStripePaymentMethodUpdate(box.enduser)">
										Mettre à jour
									</button>
								</div>

								<h4 class="fw-bold mt-2">Attestation fiscale</h4>

								<p>
									EMOTIVI étant agréé « service à la personne », vous pouvez bénéficier d’un Crédit d’impôt dans votre déclaration de l’année n équivalent à 50% du montant des abonnements versés en année n-1. Vous pouvez générer vous-mêmes l’attestation fiscale en cliquant sur le bouton ci-après.
								</p>

								<div class="text-end">
									<button class="btn btn-primary" @click="openFormAttestationFiscale(box.enduser)">
										Générer l'attestation
									</button>
								</div>

								<h4 class="fw-bold mt-2">Résilier l'abonnement</h4>

								<p>
									Initiez une demande de résiliation de votre abonnement Emotivi en cliquant sur le bouton "Résilier" ci-après.
								</p>

								<div class="text-end">
									<button class="btn btn-primary" @click="openFormCancellationRequest(box.enduser)" :disabled="cancellationInProgress(box.enduser.en_id)">
										Résilier l'abonnement
									</button>
								</div>

								<div  v-for="(cancelRequest, indexRequest) in box.cancellationRequests" :key="indexRequest">

									<h6 class="mt-4">Demande du {{ $moment(cancelRequest.createdAt).format("DD/MM/YYYY [à] HH:mm") }}</h6>
									<table class="table table-striped table-sm mb-6">
										<tbody>
											<tr>
												<td class="text-end cr_label_cell">Motif :</td>
												<td colspan="2">
													<span>
														{{ getCancellationReason(cancelRequest.cr_reason).join('. ') }}
													</span>
												</td>
											</tr>
											<tr>
												<td class="text-end cr_label_cell">Commentaire :</td>
												<td colspan="2">
													<span v-if="cancelRequest.cr_reason_comment">
														{{ cancelRequest.cr_reason_comment }}
													</span>
													<span v-else>
														 - 
													</span>
												</td>
											</tr>
											<tr>
												<td class="text-end cr_label_cell">Documents :</td>
												<td colspan="2">
													<div v-if="cancelRequest.cr_documents">
														<span  v-for="(file, fileIndex) in cancelRequest.cr_documents.list" :key="fileIndex">
															<a target="_blank" :href="`${$config.server_url}/${file.path}`" :download="file.name">{{  file.name }}</a>
														</span>
													</div>
													<div v-else> - </div>
												</td>
											</tr>
											<tr>
												<td class="text-end cr_label_cell">
													Statut :
												</td>
												<td>
													{{ getCancellationStatus(cancelRequest.cr_status) }}
												</td>
											</tr>
											<tr>
												<td class="text-end cr_label_cell">
													Mise à jour le :
												</td>
												<td>
													{{ $moment(cancelRequest.cr_status_date).format("DD/MM/YYYY [à] HH:mm") }}
												</td>
											</tr>
										</tbody>
									</table>
								</div>

							<!--/div-->
						</div>
						<!-- /BOX CONTAINER -->

					</div>
					<!-- /BOXES LOOP -->	
				</div>
			</div>
		</div>

		<div
			ref="modalPaymentMethodUpdate"
			:style="dialogUpdate.display ? 'display:block' : 'display:none'"
			:class="dialogUpdate.display ? 'modal fade show' : 'modal fade'"
			tabindex="-1"
			role="dialog"
		>
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<form id="paymentForm">
						<div class="modal-header">
							<h5 class="modal-title">{{ dialogUpdate.title }}</h5>
						</div>
						<div class="modal-body">
							<div id="payment-element"></div>
						</div>
						<div class="modal-footer">
							<button
								type="button"
								class="btn btn-secondary"
								@click="dialogActionUpdate('close')"
								:disabled="dialogUpdate.processing"
							>
							{{ dialogUpdate.close }}
							</button>
							<button
								type="submit"
								class="btn btn-primary"
								:disabled="dialogUpdate.processing"
							>
								<Icon v-if="dialogUpdate.processing" name="hourglass-half" fill="white" spin />
								{{ dialogUpdate.confirm }}
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>

		<div
			ref="modalPaymentMethodUpdateConfirm"
			:style="dialogUpdateConfirm.display ? 'display:block' : 'display:none'"
			:class="dialogUpdateConfirm.display ? 'modal fade show' : 'modal fade'"
			tabindex="-1"
			role="dialog"
		>
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
				
					<div class="modal-header">
						<h5 class="modal-title">{{ dialogUpdateConfirm.title }}</h5>
					</div>
					<div class="modal-body text-center mt-3 mb-3">
						Votre moyen de paiement a été mis à jour avec succès !
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-primary"
							@click="dialogActionUpdate('close-confirm')"
						>
							{{ dialogUpdateConfirm.close }}
						</button>
					</div>
				</div>
			</div>
		</div>

		<div
			ref="modalPaymentMethod"
			:style="dialog.display ? 'display:block' : 'display:none'"
			:class="dialog.display ? 'modal fade show' : 'modal fade'"
			tabindex="-1"
			role="dialog"
		>
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">{{ dialog.title }}</h5>
					</div>
					<div class="modal-body">
						<p>{{ dialog.body }}</p>
					</div>
					<div class="modal-footer">
						<button
						type="button"
						class="btn btn-secondary"
						@click="dialogAction('close')"
						>
						{{ dialog.close }}
						</button>
						<button
						type="button"
						class="btn btn-primary"
						@click="dialogAction('confirm')"
						>
						{{ dialog.confirm }}
						</button>
					</div>
				</div>
			</div>
		</div>

		<AttestationFiscale
			v-model="displayFormAttestationFiscale"
			@winRequestAttestationCanceled="cancelAttestationFiscale"
			:en_id="en_id"
		/>

		<CancellationRequest
			v-model="displayFormCancellationRequest"
			@winCancellationRequestReload="reloadCancellationRequest"
			@winCancellationRequestClosed="closeCancellationRequest"
			:en_id="en_id"
		/>

	</section>
</template>

<script>

import { loadStripe } from "@stripe/stripe-js";
import AttestationFiscale from "./AttestationFiscale.vue";
import CancellationRequest from "./CancellationRequest.vue";
import { h } from "vue";

export default {
	name: "privatepayments",
	components: { AttestationFiscale, CancellationRequest },
	data() {
		return {
			stripe: undefined,
			stripeElements: undefined,
			stripeBillingDetails: undefined,
			dialogErrTxt: "",
			dialogOkTxt: "",
			row_co: {},
			endusersData: [],
			boxes: [],
			depositNotPaid: false,
			isLoading: false,
			en_id: 0,
			rows_or: [],
			displaySelectEnduser: true,
			changePaymentMethod: "",
			displayFormAttestationFiscale: false,
			displayFormCancellationRequest: false,
			taxPeriod: false,
			screenWidth: window.screen.width,
			dialog: {
				title: "",
				body: "",
				confirm: "Confirmer",
				close: "Annuler",
				display: false,
			},
			dialogUpdate: {
				title: "Mettre à jour le moyen de paiement",
				body: "",
				confirm: "Mettre à jour",
				close: "Annuler",
				processing: false,
				display: false,
			},
			dialogUpdateConfirm: {
				title: "Mettre à jour le moyen de paiement",
				close: "Fermer",
				display: false,
			},
			resolveDialog: null,
			es_type: null,
		};
	},
	computed: {
		selectEndusers() {
			return this.$store.state.user.endusers.map((enduser) => {
				return { text: enduser.en_fullname, value: enduser.en_id };
			});
		},
		enduserTotal() {
			return this.$store.state.user.endusers.length;
		},
		getUniqueEnduser() {
			return this.$store.state.user.endusers[0];
		},
		hasBoxes() {
			return this.$store.state.user.endusers &&
				Array.isArray(this.$store.state.user.endusers) &&
				this.$store.state.user.endusers.length
					? this.$store.state.user.endusers.filter((enduser) => {
						return enduser.bo_id;
					}).length
					: 0;
		},
		hasTvs() {
			return this.$store.state.user.endusers &&
				Array.isArray(this.$store.state.user.endusers) &&
				this.$store.state.user.endusers.length
					? this.$store.state.user.endusers.filter((enduser) => {
						return enduser.de_id;
					}).length
					: 0;
		},
		paymentMethodsStatusText() {
			return this.$store.state.paymentMethodsStatusText;
		},
		paymentsStatusText() {
			return this.$store.state.paymentsStatusText;
		},
	},
	mounted() {
		this.loadOrders();

		if (this.enduserTotal === 1) {
			this.en_id = this.getUniqueEnduser.en_id;
		}
		document
			.querySelector("#paymentForm")
			.addEventListener("submit", this.handleStripeSubmit);
	},
	created() {
		window.addEventListener("resize", this.getScreenSize);
	},
	destroyed() {
		window.removeEventListener("resize", this.getScreenSize);
	},

	methods: {

		getCancellationStatus(value) {
			const result = this.$store.state.items_cr_statuses.find(status => status.value === value);
			return result ? result.text : "???";
		},

		getCancellationReason(value) {
			return value.split(".").map(key => {
				const result = this.$store.state.items_cr_reasons.find(reason => reason.value === key);
				return result ? result.text : "???";
			});
		},

		cancellationInProgress(en_id) {

			const statuses = {
				REQUEST_CANCELLED: 1,
				SUBSCRIPTION_CANCELLED: 1,
				KIT_INVOICE_PAID: 1,
				KIT_INVOICE_DISPUTED: 1
			};

			const enduser = this.endusersData.find(enduser => enduser.row_en.en_id === en_id);

			if(enduser) {
				const requests = enduser.rows_cr.filter(request => !statuses[request.cr_status]);

				console.log("requests ----->", requests);

				return requests.length === 0 ? false : true
			} else {
				return false;
			}
		},

		getPaymentMethodDetail(order, box) {

			const method = box.paymentMethods.find(method => {
				return method.id === order.id;
			});

			return this.formatPMDetails(method);
		},

		formatPMDetails(method) {
			if(method.pm_method_details) {
				if(method.pm_method === "rib" && method.pm_method_details.customer_bank_account) {
					return `${method.pm_method_details.customer_bank_account.bank_name} - IBAN ...${method.pm_method_details.customer_bank_account.account_number_ending}`;
				} else if(method.pm_method === "rib") {
					return `IBAN ...${method.pm_method_details.last4}`;
				} else if(method.pm_method === "cb" && method.pm_method_details.last4) {
					return `${method.pm_method_details.brand} ...${method.pm_method_details.last4}, exp: ${method.pm_method_details.exp_month}/${method.pm_method_details.exp_year}`;
				} else if(method.pm_method === "cb" && method.pm_method_details.card && method.pm_method_details.card.last4) {
					return `${method.pm_method_details.card.brand} ...${method.pm_method_details.card.last4}, exp: ${method.pm_method_details.card.exp_month}/${method.pm_method_details.card.exp_year}`;
				}
			} else {
				return "???"
			}
		},

		getOrderStatus(status) {
			const name =  {
				PAID: "payé",
			}[status];
			return name || status;
		},

		getPaymentMethodName(type) {
			const name =  {
				cb: "CB",
				rib: "SEPA"
			}[type];
			return name || type;
		},

		proceedChangePayment() {
			if (!this.en_id) return;

			this.changePayment();
		},

		async beforeStripePaymentMethodUpdate(enduser) {

			if (enduser) {
				this.en_id = enduser.en_id;
			}

			if (this.en_id) {
				return this.changePayment();
			}

			this.displaySelectEnduser = true;
		},

		async changePayment() {

			const service = `${this.$config.server_url}/web/2.0/stripe/subscription/changepayment/${this.en_id}`;
			const response = await this.$axios.get(service);
			const data = response.data.data

			if(data) {

				this.stripe = Stripe(data.stripe_apikeypublic);

				this.stripeElements = this.stripe.elements({
				appearance: {
					theme: 'stripe'
				},
				clientSecret: data.clientSecret
				});

				this.stripeBillingDetails = data.billingDetails;

				const paymentElement = this.stripeElements.create("payment", {
				fields: {
					billingDetails: 'never'
				},
				terms: {
					card: "never",
					sepaDebit: "never"
				},
				paymentMethodOrder: ["sepa_debit", "card"]
				});

				paymentElement.mount("#payment-element");


				this.dialogUpdate.display = true;
			}
		},

		async handleStripeSubmit(e) {

			e.preventDefault()

			this.dialogUpdate.processing = true;

			const {
				error
			} = await this.stripe.confirmSetup({
				elements: this.stripeElements,
				confirmParams: {
				payment_method_data: {
					billing_details: this.stripeBillingDetails
				},
				},
				redirect: 'if_required'
			});

			this.dialogUpdate.processing = false;

			console.log("🚀 ~ file: PrivatePayments.vue.eta ~ line 915 ~ handleSubmit ~ error", error);

			if(!error) {
				this.dialogUpdate.display = false;
				this.dialogUpdateConfirm.display = true;
			}
		},

		cancelSubscription(sub) {},
		// async configureBox(row_en) {
		//   // console.log("row_en", row_en);
		//   let response = await this.$axios.get(
		//     this.$config.server_url + "/web/2.0/getchallenge/" + row_en.en_id
		//   );
		//   if (response.data.err) return;
		//   this.$Utils.openConfigurationSite(
		//     row_en.en_id,
		//     row_en.en_admincode,
		//     response.data.data
		//   );
		// },

		async loadOrders() {

			this.isLoading = true;

			let response = await this.$axios.get(
				this.$config.server_url + "/web/2.0/orders"
			);

			if (!response || !response.data || !response.data.data) {
				return (this.isLoading = false);
			}

			this.endusersData = response.data.data.endusers;

			this.es_type = response.data.data.endusers[0].row_co.es_id.es_type;

			this.rows_or = response.data.data.orders

			/*this.rows_or = response.data.data.orders.filter(
				(row_or) => row_or.or_status === "PAID"
			);*/

			this.boxes = [];



			response.data.data.endusers.forEach(enduser => {

				const orders = this.rows_or.filter(order => {

					return enduser.charges.find(charge => {

						if(charge.plateform === "gocardless") {
							return charge.id === order.or_paymentid;
						} else if(charge.plateform === "stripe") {

							// Get regular subscription period
							if(charge.subscriptions_date_start && charge.subscriptions_date_end && order.or_subscription_date_start) {
								const chargePeriodStart = this.$moment(charge.subscriptions_date_start, "YYYY-MM-DD");
								const chargePeriodEnd = this.$moment(charge.subscriptions_date_end, "YYYY-MM-DD");
								const orderPeriodStart = this.$moment(order.or_subscription_date_start);
								const orderPeriodEnd = this.$moment(order.or_subscription_date_end);
								return chargePeriodStart.isSame(orderPeriodStart) && chargePeriodEnd.isSame(orderPeriodEnd);
							} 

							// Get subscription fee
							else {
								const orderPeriodStart = this.$moment(order.or_date, "YYYY-MM-DD");
								const chargePeriodStart = this.$moment(charge.created * 1000);
								return chargePeriodStart.startOf('day').isSame(orderPeriodStart);
							}
						} else {
							return false;
						}
					})
				})
			
				this.boxes.push({
					orders,
					charges: enduser.charges,
					contact: enduser.row_co,
					enduser: enduser.row_en,
					subscriptions: enduser.subscriptions.reverse(),
					paymentMethods: enduser.rows_pm,
					cancellationRequests: enduser.rows_cr
				})
			})

			this.isLoading = false;
		},
	
		openFormAttestationFiscale(enduser) {
			this.en_id = enduser.en_id;
			this.displayFormAttestationFiscale = true;
		},

		cancelAttestationFiscale() {
			this.displayFormAttestationFiscale = false;
		},

		openFormCancellationRequest(enduser) {
			this.en_id = enduser.en_id;
			this.displayFormCancellationRequest = true;
		},

		closeCancellationRequest() {
			this.displayFormCancellationRequest = false;
		},

		reloadCancellationRequest() {
			this.loadOrders();
		},

		getScreenSize(event) {
			this.screenWidth = event.target.innerWidth;
		},

		dialogActionUpdate(action) {
			if (action === "close") {
				this.dialogUpdate.display = false;
			}
			if (action === "close-confirm") {
				this.dialogUpdateConfirm.display = false;
				this.loadOrders();
			}
		},

		dialogAction(action) {
			if (action === "close") {
				this.dialog.display = false;
				this.resolveDialog.resolve(false);
			}
			if (action === "confirm") {
				this.dialog.display = false;
				this.resolveDialog.resolve(true);
			}
			this.resolveDialog = null;
		},
		confirmDialog(title, body, confirm, close) {
			this.resolveDialog = new this.Deferred();
			this.dialog.title = title;
			this.dialog.body = body;
			this.dialog.confirm = confirm;
			this.dialog.close = close;
			this.dialog.display = true;
			return this.resolveDialog.promise;
		},
		Deferred() {
			var self = this;
			this.promise = new Promise(function (resolve, reject) {
				self.reject = reject;
				self.resolve = resolve;
			});
		},
		async printOrder(item, $event) {
			$event.stopPropagation();
			window.open(
				this.$config.server_url +
				"/web/2.0/orders/" +
				item.or_id +
				"/pdf?d=" +
				new Date().getTime() +
				"&token=" +
				this.$store.state.accesstoken,
				"_blank"
			);
		},
	},
};
</script>

<style lang="scss" scoped>

.full-available-height {
	height: calc(100vh - 96px);
}

table td {
	font-size: 15px;
	vertical-align: middle;
	text-overflow: ellipsis;
}

table th {
	font-weight: normal;
	color: #006d94;
}

section {
  padding-bottom: 30px;
}

h2, h3 {
  color: #676d71;
}

h6 {	
  font-weight: bold;
}

.btn-modal {
  width: 100px;
  height: 40px;
  background-color: #1876eb;
  border: none;
  color: white;
  border-radius: 5px;
  font-size: 20px;
  margin: 5px;

  &:hover {
    background-color: #3482e0;
  }
}

.cr_label_cell {
	width: 120px;
	vertical-align: top;
}
</style>
